// geoagent/frontend/src/components/MainContent.js
import React from 'react';
import './MainContent.css'; // We'll create this CSS file next

// We will pass the map and related components as children to MainContent
const MainContent = ({ children }) => {
  return (
    <div className="main-content">
      {children}
    </div>
  );
};

export default MainContent;